import React from 'react';
import styles from '../SeoModule/SEOAuthoritySection.module.css';

const SEOAuthoritySection = () => {
  return (
    <section className={styles.wrapper}>
      <details className={styles.details}>
        <summary className={styles.summary}>
          Learn more about our software development expertise
        </summary>

        <div className={styles.content}>
          <h3>Best Software Development Company in India and Globally</h3>

          <p>
            BETA Edge is a modern Indian software development company delivering
            scalable, secure, and cost-effective digital solutions for global
            businesses. As one of the best software companies in India, we
            specialise in custom software development, mobile applications,
            cloud-native platforms, and enterprise-grade systems.
          </p>

          <p>
            Our India-based delivery model allows clients to pay in INR, reducing
            exposure to international pricing volatility and recent tariff
            fluctuations. This makes BETA Edge a preferred technology partner
            for startups and enterprises seeking high-quality engineering at
            sustainable costs.
          </p>

          <p>
            We follow proven development methodologies, transparent workflows,
            and security-first practices. Businesses across industries trust us
            for long-term digital transformation, product engineering and
            technology consulting services.
          </p>

          <p>
            If you are searching for the best software development companies in
            India, BETA Edge offers a balance of technical excellence, strategic
            thinking and operational reliability.
          </p>

          <p>
            Our client base spans Singapore, New Zealand, Japan, Malaysia, the
            UK, Canada and the USA in addition to India, and our delivery
            track record is backed by verified 5-star reviews from
            fintech, healthcare, manufacturing, logistics and retail clients
            worldwide.
          </p>
        </div>
      </details>
    </section>
  );
};

export default SEOAuthoritySection;
